import OldInspectionsPageTable from './OldInspectionsPageTable';

export default OldInspectionsPageTable;
